/** Material UI Packages. */
import { Box, LinearProgress } from '@mui/material';

import dayjs from 'dayjs';

/**
 * Determin the class for the 'type' column based on value('Detention' and 'Demurrage').
 * @param {object} params - The cell parameters.
 * @returns {string} - The class name based on the 'type' value.
 */
const getTypeData = (params) => {
    const type = params.value;
    if (type === 'perdiem') {
        return 'detention-cell';
    } else return 'demurrage-cell';
};

/** Define a datagrid columns for ISF Filing. */
export const isfCol = [
    {
        field: 'id',
        headerName: 'ID',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        sortable: false,
        hideable: false,
        hide: true,
        pinnable: false,
    },
    {
        field: 'client',
        headerName: 'CLIENT',
        flex: 0.5,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'shipper',
        headerName: 'SHIPPER',
        flex: 0.5,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'reference',
        headerName: 'HBL#',
        flex: 0.5,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'attr_value',
        headerName: 'STATUS',
        flex: 0.4,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
];

/** Define a datagrid columns for Customs Clearance. */
export const customsCol = [
    {
        field: 'id',
        headerName: 'ID',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        sortable: false,
        hideable: false,
        hide: true,
        pinnable: false,
    },
    {
        field: 'il_opus_reference_id',
        headerName: 'OPUS#',
        flex: 0.7,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'reference',
        headerName: 'HBL/ALIAS/BOL#',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'attr_value',
        headerName: 'STATUS',
        flex: 0.6,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
];

/** Define a datagrid columns for Delivery Order. */
export const deliveryOrderCol = [
    {
        field: 'id',
        headerName: 'ID',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        sortable: false,
        hideable: false,
        hide: true,
        pinnable: false,
    },
    {
        field: 'client',
        headerName: 'CLIENT',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'shipper',
        headerName: 'SHIPPER',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'consignee',
        headerName: 'CNEE',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'reference',
        headerName: 'CNTR/ALIAS#',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'ref_location_pick_up',
        headerName: 'PICK UP',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
        renderCell: (params) => params.value ?? '-',
    },
    {
        field: 'ref_location_deliver_to',
        headerName: 'DELIVER TO',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
        renderCell: (params) => params.value ?? '-',
    },
    {
        field: 'attr_value',
        headerName: 'STATUS',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
];

/** Define a datagrid columns for DG/HAZAT Document, Shipping Instruction. */
export const exportDocumentCol = [
    {
        field: 'id',
        headerName: 'ID',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        sortable: false,
        hideable: false,
        hide: true,
        pinnable: false,
    },
    {
        field: 'header',
        headerName: 'TASK',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'il_opus_reference_id',
        headerName: 'OPUS#',
        flex: 0.5,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'reference',
        headerName: 'MBL#',
        flex: 0.7,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'attr_value',
        headerName: 'STATUS',
        flex: 0.6,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
];

/** Define a datagrid columns for AES ITN Filing. */
export const aesitnCol = [
    {
        field: 'id',
        headerName: 'ID',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        sortable: false,
        hideable: false,
        hide: true,
        pinnable: false,
    },
    {
        field: 'il_opus_reference_id',
        headerName: 'OPUS#',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'attr_value',
        headerName: 'STATUS',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
];

/** Define a datagrid columns for Customs Hold. */
export const customsHoldCol = [
    {
        field: 'id',
        headerName: 'ID',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        sortable: false,
        hideable: false,
        hide: true,
        pinnable: false,
    },
    {
        field: 'il_opus_reference_id',
        headerName: 'OPUS#',
        flex: 0.5,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'reference',
        headerName: 'HBL/HAWB#',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'attr_value',
        headerName: 'STATUS',
        flex: 0.8,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
];

/** Define a datagrid columns for ETD, ETA, Pickup, Delivery, Rail location Input. */
export const inputCol = [
    {
        field: 'id',
        headerName: 'ID',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        sortable: false,
        hideable: false,
        hide: true,
        pinnable: false,
    },
    {
        field: 'header',
        headerName: 'TASK',
        flex: 1.2,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'il_opus_reference_id',
        headerName: 'OPUS#',
        flex: 0.8,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
];
/** Define a datagrid columns for MBL, HBL Release. */
export const releaseCol = [
    {
        field: 'id',
        headerName: 'ID',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        sortable: false,
        hideable: false,
        hide: true,
        pinnable: false,
    },
    {
        field: 'header',
        headerName: 'TYPE',
        flex: 0.5,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
        renderCell: (params) => {
            const original = params.value || '';
            const cleaned = original.replace(/release/gi, '').trim(); // 'release' 제거 (대소문자 무시)
            return cleaned;
        },
    },
    {
        field: 'il_opus_reference_id',
        headerName: 'OPUS#',
        flex: 0.7,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'reference',
        headerName: 'MBL/HBL#',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'attr_value',
        headerName: 'STATUS',
        flex: 0.8,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
];

/** Define a datagrid columns for Empty Container. */
export const emptyContainerCol = [
    {
        field: 'id',
        headerName: 'ID',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        sortable: false,
        hideable: false,
        hide: true,
        pinnable: false,
    },
    {
        field: 'il_opus_reference_id',
        headerName: 'OPUS#',
        flex: 0.6,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'reference',
        headerName: 'CNTR#',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'attr_value',
        headerName: 'STATUS',
        flex: 0.7,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
];

/** Define a datagrid columns for Booking Confirmation. */
export const bookingConfirmationCol = [
    {
        field: 'id',
        headerName: 'ID',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        sortable: false,
        hideable: false,
        hide: true,
        pinnable: false,
    },
    {
        field: 'il_opus_reference_id',
        headerName: 'OPUS#',
        flex: 0.5,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'reference',
        headerName: 'MBL/MAWB#',
        flex: 0.5,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'attr_value',
        headerName: 'STATUS',
        flex: 0.7,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
];

/** Define a datagrid columns for Stages. */
export const stagesCol = [
    {
        field: 'id',
        headerName: 'ID',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        sortable: false,
        hideable: false,
        hide: true,
        pinnable: false,
    },
    {
        field: 'il_opus_reference_id',
        headerName: 'OPUS#',
        flex: 0.7,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'reference',
        headerName: 'CNTR/ALIAS#',
        flex: 0.8,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'attr_value',
        headerName: 'STATUS',
        flex: 0.7,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
];

/** Define a datagrid columns for Proof. */
export const proofCol = [
    {
        field: 'id',
        headerName: 'ID',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        sortable: false,
        hideable: false,
        hide: true,
        pinnable: false,
    },
    {
        field: 'reference',
        headerName: 'CNTR/ALIAS/BOL#',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'attr_value',
        headerName: 'STATUS',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
];

/** Define a datagrid columns for approaching LFD cargo. */
export const lfdCol = [
    {
        field: 'id',
        headerName: 'ID',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        sortable: false,
        hideable: false,
        hide: true,
        pinnable: false,
    },
    {
        field: 'todo_key',
        headerName: 'TYPE',
        flex: 1.1,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
        cellClassName: getTypeData,
        renderCell: (params) => {
            const value = params.value;
            if (!value || typeof value !== 'string') return '';

            if (value.toLowerCase() === 'perdiem') {
                return 'Detention';
            }

            return value.charAt(0).toUpperCase() + value.slice(1);
        },
    },
    {
        field: 'client',
        headerName: 'CLIENT',
        flex: 1.5,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'reference',
        headerName: 'CNTR#',
        flex: 1.4,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'ref_datetime',
        headerName: 'LFD',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
        renderCell: (params) => {
            if (!params.value) return '';
            const localDate = dayjs(params.value).format('MM/DD');
            return localDate;
        },
    },
];

/** Define a datagrid columns for Ocean Freight. */
export const oceanFreightCol = [
    {
        field: 'id',
        headerName: 'ID',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        sortable: false,
        hideable: false,
        hide: true,
        pinnable: false,
    },
    {
        field: 'il_opus_reference_id',
        headerName: 'OPUS#',
        flex: 0.5,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'attr_value',
        headerName: 'STATUS',
        flex: 0.8,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    // {
    //     field: 'step_value',
    //     headerName: 'PROGRESS',
    //     flex: 0.8,
    //     align: 'center',
    //     headerAlign: 'center',
    //     hideable: false,
    //     pinnable: false,
    //     renderCell: (params) => {
    //         const row = params.row;
    //         const currentStep = row.step;
    //         const totalSteps = row.step_value;

    //         if (typeof currentStep !== 'number' || typeof totalSteps !== 'number' || totalSteps === 0) {
    //             return '-';
    //         }

    //         const progress = Math.round((currentStep / totalSteps) * 100);

    //         return (
    //             <Box
    //                 sx={{
    //                     height: '100%',
    //                     width: '100%',
    //                     px: 0.5,
    //                     display: 'flex',
    //                     alignItems: 'center',
    //                     justifyContent: 'center',
    //                 }}
    //             >
    //                 <LinearProgress
    //                     variant="determinate"
    //                     value={progress}
    //                     sx={{
    //                         width: '100%',
    //                         height: 8,
    //                         borderRadius: 5,
    //                         backgroundColor: '#f0f0f0',
    //                         '& .MuiLinearProgress-bar': {
    //                             backgroundColor: 'primary',
    //                         },
    //                     }}
    //                 />
    //             </Box>
    //         );
    //     },
    // },
];

/** Define a datagrid columns for Air Freight. */
export const airFreightCol = [
    {
        field: 'id',
        headerName: 'ID',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        sortable: false,
        hideable: false,
        hide: true,
        pinnable: false,
    },
    {
        field: 'il_opus_reference_id',
        headerName: 'OPUS#',
        flex: 0.5,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'attr_value',
        headerName: 'STATUS',
        flex: 0.8,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
];

/** Define a datagrid columns for Pierpass. */
export const pierpassCol = [
    {
        field: 'id',
        headerName: 'ID',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        sortable: false,
        hideable: false,
        hide: true,
        pinnable: false,
    },
    {
        field: 'il_opus_reference_id',
        headerName: 'OPUS#',
        flex: 0.7,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'reference',
        headerName: 'CNTR#',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'attr_value',
        headerName: 'STATUS',
        flex: 0.8,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'step_value',
        headerName: 'PROGRESS',
        flex: 0.8,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
        renderCell: (params) => {
            const row = params.row;
            const currentStep = row.step;
            const totalSteps = row.step_value;

            if (typeof currentStep !== 'number' || typeof totalSteps !== 'number' || totalSteps === 0) {
                return '-';
            }

            const progress = Math.round((currentStep / totalSteps) * 100);

            return (
                <Box
                    sx={{
                        height: '100%',
                        width: '100%',
                        px: 0.5,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <LinearProgress
                        variant="determinate"
                        value={progress}
                        sx={{
                            width: '100%',
                            height: 8,
                            borderRadius: 5,
                            backgroundColor: '#f0f0f0',
                            '& .MuiLinearProgress-bar': {
                                backgroundColor: 'primary',
                            },
                        }}
                    />
                </Box>
            );
        },
    },
];

/** Define a datagrid columns for Import Service Fee. */
export const importServiceFeeCol = [
    {
        field: 'id',
        headerName: 'ID',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        sortable: false,
        hideable: false,
        hide: true,
        pinnable: false,
    },
    {
        field: 'il_opus_reference_id',
        headerName: 'OPUS#',
        flex: 0.7,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'reference',
        headerName: 'HAWB#',
        flex: 0.9,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'attr_value',
        headerName: 'STATUS',
        flex: 0.9,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
];

/** Define a datagrid columns for Cargo Departure, Cargo Arrival. */
export const cargoScheduleCol = [
    {
        field: 'id',
        headerName: 'ID',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        sortable: false,
        hideable: false,
        hide: true,
        pinnable: false,
    },
    {
        field: 'header',
        headerName: 'TYPE',
        flex: 0.7,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
        renderCell: (params) => {
            const value = params.value;
            if (!value || typeof value !== 'string') return '';
            return value.replace(/Cargo/gi, '').trim();
        },
    },
    {
        field: 'il_opus_reference_id',
        headerName: 'OPUS#',
        flex: 0.6,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
];

/** Define a datagrid columns for PreAlert. */
export const prealertCol = [
    {
        field: 'id',
        headerName: 'ID',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        sortable: false,
        hideable: false,
        hide: true,
        pinnable: false,
    },
    {
        field: 'il_opus_reference_id',
        headerName: 'OPUS#',
        flex: 0.4,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'client',
        headerName: 'CLIENT',
        flex: 0.5,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'shipper',
        headerName: 'SHIPPER',
        flex: 0.5,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'reference',
        headerName: 'HBL/HAWB#',
        flex: 0.7,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
];

/** Define a datagrid columns for Arrival Notice. */
export const arrivalNoticeCol = [
    {
        field: 'id',
        headerName: 'ID',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        sortable: false,
        hideable: false,
        hide: true,
        pinnable: false,
    },
    {
        field: 'il_opus_reference_id',
        headerName: 'OPUS#',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'client',
        headerName: 'CLIENT',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'shipper',
        headerName: 'SHIPPER',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'attr_value',
        headerName: 'STATUS',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
];

/** Define a datagrid columns for Pickup, Prepull, Delivery appointment. */
export const appointmentCol = [
    {
        field: 'id',
        headerName: 'ID',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        sortable: false,
        hideable: false,
        hide: true,
        pinnable: false,
    },
    {
        field: 'header',
        headerName: 'TASK',
        flex: 0.7,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
        renderCell: (params) => {
            const value = params.value;
            if (!value || typeof value !== 'string') return '';
            return value.replace(/Status/gi, '').trim();
        },
    },
    {
        field: 'il_opus_reference_id',
        headerName: 'OPUS#',
        flex: 0.7,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'client',
        headerName: 'CLIENT',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'reference',
        headerName: 'CNTR/ALIAS#',
        flex: 0.9,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'ref_datetime',
        headerName: 'APPT',
        flex: 0.9,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
        renderCell: (params) => {
            if (!params.value) return '';
            return params.value ? dayjs(params.value).format('MM/DD @ HH:mm') : '';
        },
    },
];

/** Define a datagrid columns for Pickup, Prepull, Delivery appointment. */
export const schedulingCol = [
    {
        field: 'id',
        headerName: 'ID',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        sortable: false,
        hideable: false,
        hide: true,
        pinnable: false,
    },
    {
        field: 'header',
        headerName: 'TASK',
        flex: 0.7,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
        renderCell: (params) => {
            const value = params.value;
            if (!value || typeof value !== 'string') return '';
            return value.replace(/Status/gi, '').trim();
        },
    },
    {
        field: 'il_opus_reference_id',
        headerName: 'OPUS#',
        flex: 0.7,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'client',
        headerName: 'CLIENT',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'reference',
        headerName: 'CNTR/ALIAS#',
        flex: 0.9,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'ref_datetime',
        headerName: 'APPT',
        flex: 0.9,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
        renderCell: (params) => {
            if (!params.value) return '';
            return params.value ? dayjs(params.value).format('MM/DD @ HH:mm') : '';
        },
    },
];

/** Define a datagrid columns for Invoice, Credit/Debit Note. */
export const financeCol = [
    {
        field: 'id',
        headerName: 'ID',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        sortable: false,
        hideable: false,
        hide: true,
        pinnable: false,
    },
    {
        field: 'il_opus_reference_id',
        headerName: 'OPUS#',
        flex: 0.5,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'attr_value',
        headerName: 'STATUS',
        flex: 0.8,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
];

/** Define a datagrid columns for Disputing. */
export const disputeCol = [
    {
        field: 'id',
        headerName: 'ID',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        sortable: false,
        hideable: false,
        hide: true,
        pinnable: false,
    },
    {
        field: 'il_opus_reference_id',
        headerName: 'OPUS#',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
];

/** Define a datagrid columns for Client Closure, Case Closure. */
export const closureCol = [
    {
        field: 'id',
        headerName: 'ID',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        sortable: false,
        hideable: false,
        hide: true,
        pinnable: false,
    },
    {
        field: 'header',
        headerName: 'TYPE',
        flex: 0.8,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'il_opus_reference_id',
        headerName: 'OPUS#',
        flex: 0.5,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
];

/** Define a datagrid columns for Comment Todo. */
export const commentCol = [
    {
        field: 'id',
        headerName: 'ID',
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        sortable: false,
        hideable: false,
        hide: true,
        pinnable: false,
    },
    {
        field: 'il_opus_reference_id',
        headerName: 'OPUS#',
        flex: 0.5,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
    {
        field: 'description',
        headerName: 'MESSAGE',
        flex: 1.5,
        align: 'center',
        headerAlign: 'center',
        hideable: false,
        pinnable: false,
    },
];
